import { TimeSlot } from '../TimeSlot';
import { City } from '../WSClasses';
import { ConvDataDefinition } from './ConvDataDefinition';

export class ConvCode {
    public id: number;
    public code: string;
    public enabled: boolean;
    public title: string;
    public description: string;
    public timeslots: TimeSlot[];
    public convDataDefinitions: ConvDataDefinition[];
    public city: City;
    public cityId: number;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        Object.assign(this, obj);
    }
}